import { Privilege } from "pages/govern/Roles/PrivilegesTransaction";

export const getGrantStatements = ({
  accountName,
  roleName,
  organizationName,
  privilege,
  isOrganizationRole,
}: {
  accountName?: string;
  organizationName?: string;
  roleName: string;
  privilege: Privilege;
  isOrganizationRole?: boolean;
}) => {
  const { actions, resource } = privilege;
  const type =
    privilege.type === "role" && isOrganizationRole
      ? "organization role"
      : privilege.type;
  const statements = actions.map(action => {
    if (type === "organization" && organizationName) {
      const statement = `GRANT ${action} on ORGANIZATION "${organizationName}" TO ORGANIZATION ROLE "${roleName}";\n`;
      return statement;
    }
    if (type === "account" && accountName) {
      const statement = `GRANT ${action} on ACCOUNT "${accountName}" TO "${roleName}";\n`;
      return statement;
    }

    const statement = organizationName
      ? `GRANT ${action} on ${type} "${resource}" TO ORGANIZATION ROLE "${roleName}";\n`
      : `GRANT ${action} ON ${type} "${resource}" TO "${roleName}";\n`;
    return statement;
  });
  return statements;
};

export const getRevokeStatements = ({
  accountName,
  organizationName,
  roleName,
  privilege,
  isOrganizationRole,
}: {
  accountName?: string;
  organizationName?: string;
  roleName: string;
  privilege: Privilege;
  isOrganizationRole?: boolean;
}) => {
  const { actions, resource } = privilege;
  const type =
    privilege.type === "role" && isOrganizationRole
      ? "organization role"
      : privilege.type;
  const statements = actions.map(action => {
    if (type === "organization" && organizationName) {
      const statement = `REVOKE ${action} on ORGANIZATION "${organizationName}" FROM ORGANIZATION ROLE "${roleName}";\n`;
      return statement;
    }
    if (type === "account" && accountName) {
      const statement = `REVOKE ${action} ON ACCOUNT "${accountName}" FROM "${roleName}";\n`;
      return statement;
    }

    const statement = organizationName
      ? `REVOKE ${action} ON ${type} "${resource}" FROM ORGANIZATION ROLE "${roleName}";\n`
      : `REVOKE ${action} ON ${type} "${resource}" FROM "${roleName}";\n`;
    return statement;
  });
  return statements;
};
